import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const arjSettingsPermissionsRoute: InvariantJiraRoute = {
	name: 'arj-settings-permissions',
	path: '/jira/plans/settings/permissions',
};
